import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AMENITIES, AmenityCategory, AmenityId } from '../types/amenity';
import { AMENITY_ICONS } from './AmenityIcons';

const CATEGORY_ORDER: AmenityCategory[] = [
  'kitchen',
  'laundry',
  'bathroom',
  'climate',
  'entertainment',
  'sports',
  'outdoor',
  'safety',
  'connectivity',
  'parking',
];

interface AmenitiesSummaryProps {
  amenities: AmenityId[];
}

export const AmenitiesSummary: React.FC<AmenitiesSummaryProps> = ({ amenities }) => {
  const { t } = useTranslation();

  if (amenities.length === 0) {
    return null;
  }

  const selected = AMENITIES.filter((a) => amenities.includes(a.id));
  const grouped = CATEGORY_ORDER.map((cat) => ({
    category: cat,
    items: selected.filter((a) => a.category === cat),
  })).filter((g) => g.items.length > 0);

  return (
    <Stack spacing={1.5}>
      {grouped.map(({ category, items }) => (
        <Box key={category}>
          <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
            {t(`amenities.categories.${category}`)}
          </Typography>
          <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
            {items.map((amenity) => (
              <Chip
                key={amenity.id}
                icon={AMENITY_ICONS[amenity.id]}
                label={t(`amenities.items.${amenity.id}`)}
                size="small"
                variant="outlined"
              />
            ))}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};
